import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#315659",
    },
    secondary: {
      main: "#BCAB79",
      contrastText: "white",
    },
    diable: {
      main: "#e7e7e7",
      contrastText: "white",
    },
    transparent: {
      main: "rgba(255, 255, 255, 0)",
    },
    textDisable: {
      main: "#D6D6D6",
    },
    secondaryButton: {
      main: "#253031",
      contrastText: "white",
    },
    approve: {
      main: "#41D269",
      contrastText: "white",
    },
    
    send: {
      main: "#2978A0",
      contrastText: "white",
    },
    reject: {
      main: "#E8505B",
      contrastText: "white",
    },
    delete: {
      main: "#FF5F5F",
      contrastText: "white",
    },
    view: {
      main: "#BCAB79",
      contrastText: "white",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
          "&:focus": {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
